import Analytics from 'analytics';
import { YANDEX_COUNTER_ID, isProduction } from 'constants/env';
import yandexMetrica from './yandexMetrica';

const plugins = [
  yandexMetrica({
    ymId: YANDEX_COUNTER_ID,
  }),
];

const analytics = Analytics({
  app: 'Ironman',
  plugins: [...(isProduction ? plugins : [])],
});

export default analytics;
